import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {usePrice} from "../hooks/usePrice.ts";
import {
    BillingPeriod,
    Price,
    PriceStatus,
    PricingModel,
    RecurringOption
} from "../types.ts";
import {useParams} from "react-router-dom";

export const AddFormDrawer = (props: DrawerProps) => {
    const {id: productId} = useParams();

    if (!productId) {
        throw new Error('productId is required');
    }

    const {
        createRecord,
    } = usePrice(productId);

    return (
        <FormDrawer
            record={{
                id: '',
                productId: productId,
                priceStatus: PriceStatus.Active,
                pricingModel: PricingModel.FlatRate,
                recurringOption: RecurringOption.Yes,
                billingPeriod: BillingPeriod.Monthly,
                amount: 0,
                ratePlanId: '',
                description: '',
            } as Price}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
